import es from './es.json';
import esMX from './es-MX.json';
import ptBR from './pt-BR.json';

export const resources = {
  'pt-BR': { translation: ptBR },
  es: { translation: es },
  'es-MX': { translation: esMX },
};
